import payment from './../../../services/purchase/payment'

export default {
    namespaced: false,
    state: {
        bankAccounts: []
    },
    getters: {
        bankAccounts: state => state.bankAccounts
    },
    mutations: {
        setBankAccounts: (state, payload) => state.bankAccounts = payload
    },
    actions: {
        getBankAccounts(context) {
            return new Promise((resolve, reject) => {
                payment.bankAccounts().then(response => {
                    resolve(response);
                    context.commit("setBankAccounts", response.data);
                }).catch(error => {
                    reject(error);
                })
            });
        } 
    }
}